/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Validation_Reasonrequired3Inputs */

const en_coinvestments_declinedeal_validation_reasonrequired3 = /** @type {(inputs: Coinvestments_Declinedeal_Validation_Reasonrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a reason for declining`)
};

/**
* | output |
* | --- |
* | "Please select a reason for declining" |
*
* @param {Coinvestments_Declinedeal_Validation_Reasonrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_validation_reasonrequired3 = /** @type {((inputs?: Coinvestments_Declinedeal_Validation_Reasonrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Validation_Reasonrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_validation_reasonrequired3(inputs)
});
export { coinvestments_declinedeal_validation_reasonrequired3 as "coInvestments_declineDeal_validation_reasonRequired" }